import { CONFIG_OPTIONS } from '../config/config-options';
declare const window: any;

/**
 * jsbridge api => app version
 */
const suportVersion = {
  IOS: {
    setSwidVer: '10.3.0',
    accessibilityVer: '11.1.0',
    deviceInfoVer: '13.7.0',
    getLoginInfoVer: '13.7.0',
    easyLoginCompleteVer: '13.7.0',
    getThirdAuthCodeVer: '13.7.0',
  },
  ANDROID: {
    setSwidVer: 10300,
    accessibilityVer: 11100,
    deviceInfoVer: 13700,
    getLoginInfoVer: 13700,
    easyLoginCompleteVer: 13700,
    getThirdAuthCodeVer: 13700,
  }
}

/**
 * Disney app IOS: DISNEY_MOBILE_IOS/9.1, language/zh, Mozilla/5.0 (iPhone; CPU iPhone OS 14_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148
 * Disney app Android: DISNEY_MOBILE_ANDROID/9100,language/zh,Mozilla/5.0 (Linux; Android 10; Redmi K20 Pro Premium Edition Build/QKQ1.190825.002; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/83.0.4103.101 Mobile Safari/537.36
 */

export const WECHAT = 'Wechat';
export const MINI_PROGRAM = 'Miniprogram';
export const DISNEY_IOS = 'DisneyIOS';
export const DISNEY_ANDROID = 'DisneyAndroid';
export const MOBILE = 'Mobile';
export const BROWSER = 'Browser';

export class PlatformDetect {
  public userAgent;

  constructor() {
    this.userAgent = navigator.userAgent;
  }

  isWx() {
    const pattern = /MicroMessenger/;
    return pattern.test(this.userAgent);
  }

  isMiniP() {
    const pattern = /[m|M]ini[p|P]rogram/;
    return pattern.test(this.userAgent);
  }

  isDisneyIOS() {
    const pattern = /DISNEY_MOBILE_IOS/;
    return pattern.test(this.userAgent);
  }

  isDisneyAndroid() {
    const pattern = /DISNEY_MOBILE_ANDROID/;
    return pattern.test(this.userAgent);
  }

  isAndroid() { 
    const pattern = /android/;
    return pattern.test(this.userAgent.toLocaleLowerCase());
  }

  isApp() {
    return this.isDisneyAndroid() || this.isDisneyIOS();
  }

  isIPad() {
    const pattern = /(iPad|PlayBook)/;
    return pattern.test(this.userAgent.toLocaleLowerCase());
  }

  isMobile() {
    const pattern = /Mobile/;
    return pattern.test(this.userAgent);
  }

  isMobl() {
    return /(phone|pad|pod|iPhone|iPod|ios|webOS|iPad|Android|Mobile|Opera Mini|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
  }

  isWeb = ()=> {
    return this.isPcWeb() || this.isMobileWeb();
  }

  isPcWeb = () => { 
    return !this.isMobl() && !this.isWx() && !this.isApp();
  }

  isMobileWeb = () => { 
    const isMobl = this.isMobl();
    const isWeb = !this.isWx() && !this.isApp();
    const userAg = window.navigator?.userAgentData;
    let isMobile = false;
    if (userAg) {
      userAg.getHighEntropyValues(['platform', 'mobile']).then(ua => {
        if (ua.mobile) {
          isMobile = true;
        }
      });
      return (isMobl || isMobile) && isWeb;
    } else { 
      return isMobl && isWeb;
    }
  }

  detect() {
    return this.isWx() ? (this.isMiniP() ? MINI_PROGRAM : WECHAT) :
      (this.isDisneyIOS() ? DISNEY_IOS :
        ( this.isDisneyAndroid() ? DISNEY_ANDROID :
          ( this.isPcWeb() ? BROWSER : MOBILE)));
  }

  getPlatform() {
    return this.isWx() ? 'wechat' : (this.isApp() ? 'app' : 'browser');
  };

  getAndroidAppVersion(key: string){
    return suportVersion.ANDROID[`${key}`];
  }

  getIosAppVersion(key: string){
    return suportVersion.IOS[`${key}`]
  }

  /**
  * @param key : jsbridge api support version key
  * check if guest's currentVer(current app version) support current function(like: setSwid | accessibility | getSystemInfo)
  * bool = 0 | 1 | -1 
  * 0: currentVer = defaultVer(default last support version)
  * 1: currentVer > defaultVer
  * -1: currentVer < defaultVer
  */
  getShdrAppVersion(key: string) { 
    let version; 
    let bool = -1
    const pattern = /DISNEY_MOBILE_.+\/(.+?)\,/;
    if(this.isDisneyAndroid()){
      const patternSystem = "DISNEY_MOBILE_ANDROID/";
      const uaInfo = pattern.exec(this.userAgent); // app userAgent info
      console.log('getShdrAppVersion uaInfo..', uaInfo);
      if(uaInfo.length > 0){
        console.log('getShdrAppVersion patternSystem..', uaInfo[0].split(patternSystem)[1]?.split(','));
        version = Number(uaInfo[0].split(patternSystem)[1]?.split(',')[0]);
        console.log('getShdrAppVersion version..', version);
        const defaultVer = this.getAndroidAppVersion(key); // default version from suportVersion
        bool = (version === defaultVer) ? 0 : ((version > defaultVer) ? 1 : -1);
      }

    } else if(this.isDisneyIOS()) {
      const patternSystem = "DISNEY_MOBILE_IOS/";
      const uaInfo = pattern.exec(this.userAgent); // app userAgent info
      console.log('getShdrAppVersion ios uaInfo..', uaInfo);
      if(uaInfo.length > 0){
        console.log('getShdrAppVersion ios patternSystem..', uaInfo[0].split(patternSystem)[1]?.split(','));
        version = uaInfo[0].split(patternSystem)[1]?.split(',')[0]
        bool = this.versionCompare(version, this.getIosAppVersion(key))
      }
    }
    return bool

  }

  /**
   * @param curVer : current app version
   * @param lastVer : default last version from suportVersion 
   * @returns 0 | 1 | -1
   */

  versionCompare(curVer = '', lastVer = ''): number {
    if(curVer === lastVer) return 0;
    const curArr = curVer.split('.');
    const lastArr = lastVer.split('.');
    const curLength = curArr.length;
    const lastLength = lastArr.length;
    const maxL = Math.max(curLength, lastLength);
    let result = 0;
    for (let i = 0; i < maxL; i++) {  
        let curNum = curLength>i ? parseInt(curArr[i]) : 0;
        let lastNum = lastLength>i ? parseInt(lastArr[i]) : 0;
        if (curNum < lastNum) {
          result = -1;
          break;
        } else if (curNum > lastNum) { 
          result = 1;
          break;
        }
    }
    return result;
  }

}

export const platformDetectProvider = {
  provide: PlatformDetect,
  useClass: PlatformDetect,
  deps: [CONFIG_OPTIONS]
};